import React, {useState, useContext} from 'react'
import { useMutation } from "@apollo/client";
import { Box, Text, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router";
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import { LoadingOverlay } from '../../components/LoadingOverlay';
import {
    CREATE_CONNECTED_ACCOUNT_LINK
  } from "../../graphql/mutations";
  import { refresh_url, return_url } from "../../config";
import { HelmetComponent } from '../../components/HelmetComponent';

export const StripeReturnURLPage = () => {

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()
    const { user, publisher } = useContext(PublisherAndUserContext);

    const createNewConnectAccountLink = () => {
        setLoading(true)
        createConnectAccountLink({
            variables: {
                data: {
                    refresh_url: refresh_url,
                    return_url: return_url
                },
                where: {
                    id: publisher?.id
                }
            }
        })
    }
    const [createConnectAccountLink] = useMutation(CREATE_CONNECTED_ACCOUNT_LINK, {
        onCompleted: (data) => {
            setLoading(false)
            window.open(data.edshopifyCreateSConnectedAccountLink.url, "_self")
        },
        onError: () => {
            setLoading(false)
        },
    });

    return (
        <Box>
            <HelmetComponent title={`Expired Link - Home - ${user.firstName} ${user.lastName}`}/>
            {loading && <LoadingOverlay />}
            <Text>The onboarding link got expired.</Text>
            <Button mt={3} colorScheme="blue" fontWeight="regular" onClick={createNewConnectAccountLink}>
                Connect with <Text as="span" ml={1} fontWeight="800">Stripe</Text>
            </Button>
        </Box>
    )
}
